"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_EVENT_TYPES = exports.SESSION_EVENTS = exports.PREFIX = exports.MODE = exports.DEFAULT_KEY = exports.DEFAULT_INACTIVE_MS = exports.DEFAULT_EXPIRES_MS = void 0;
const PREFIX = exports.PREFIX = 'NRBA';
const DEFAULT_KEY = exports.DEFAULT_KEY = 'SESSION';
const DEFAULT_EXPIRES_MS = exports.DEFAULT_EXPIRES_MS = 14400000;
const DEFAULT_INACTIVE_MS = exports.DEFAULT_INACTIVE_MS = 1800000;
const SESSION_EVENTS = exports.SESSION_EVENTS = {
  STARTED: 'session-started',
  PAUSE: 'session-pause',
  RESET: 'session-reset',
  RESUME: 'session-resume',
  UPDATE: 'session-update'
};
const SESSION_EVENT_TYPES = exports.SESSION_EVENT_TYPES = {
  SAME_TAB: 'same-tab',
  CROSS_TAB: 'cross-tab'
};
const MODE = exports.MODE = {
  OFF: 0,
  FULL: 1,
  ERROR: 2
};